import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import localizedStrings from 'localization';
import {
  PublishShowcaseAppletsContainer,
  PublishShowcaseDescription,
  QuestSectionTitle,
} from 'modules/profile/components';
import { selectQuestPortfolioApplets } from 'modules/applets/selectors';
import AppletPreview from 'modules/profile/portfolio/quest-applets/AppletPreview';
import { StepPropsSplit } from './typings';
import { buildQuestAppletsList } from 'helpers/AppletHelpers';
import useIsAppletSelected from 'hooks/useIsAppletSelected';
import useHandleAppletSelect from 'hooks/useHandleAppletSelect';
import { FieldErrorMessage } from 'components/input-field/components';
import CollapsibleOutlined from 'components/collapsible-outlined';

const SelectFeaturedArtifacts = ({
  values,
  setFieldValue,
}: StepPropsSplit) => {
  const questPortfolioApplets = useSelector(selectQuestPortfolioApplets);

  const applets = useMemo(
    () =>
      buildQuestAppletsList(questPortfolioApplets),
    [questPortfolioApplets],
  );

  const handleAppletSelect = useHandleAppletSelect(
    setFieldValue,
    values?.featuredApplets || [],
    'featuredApplets',
  );

  const isSelected = useIsAppletSelected(values?.featuredApplets || []);

  return (
    <>
      <CollapsibleOutlined
        dataTestid="CollapsibleOutlined-SelectFeaturedArtifacts"
        title={<QuestSectionTitle>{localizedStrings.featuredArtifactsIncluded}</QuestSectionTitle>}
        initOpen={false}
        childrenSelected={<>
          <PublishShowcaseAppletsContainer>
            {applets
              .filter(isSelected)
              .map((applet) => {
                return (
                  <AppletPreview
                    key={applet.id}
                    applet={applet}
                    onAppletClick={() => { }}
                    showTitle={true}
                    height="168px"
                    width="178px"
                  />
                )
              })}
          </PublishShowcaseAppletsContainer>
        </>}
      >
        <PublishShowcaseDescription>
          {!applets?.length ? (
            <FieldErrorMessage>
              {localizedStrings.showcaseFeaturedArtifactMinimumError}
            </FieldErrorMessage>
          ) : localizedStrings.selectShowcaseFeatured}
        </PublishShowcaseDescription>

        <PublishShowcaseAppletsContainer>
          {applets.map((applet) => (
            <AppletPreview
              key={applet.id}
              applet={applet}
              onAppletClick={handleAppletSelect}
              showTitle={true}
              height="168px"
              width="178px"
              selected={isSelected(applet)}
            />
          ))}
        </PublishShowcaseAppletsContainer>
      </CollapsibleOutlined>
    </>
  )
};

export default SelectFeaturedArtifacts;
